module.exports = __webpack_public_path__ + "img/DE02539.d5df8c78.png";